import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { alteracoesNaoSalvasGuard } from '../../core/guards/alteracoes-nao-salvas.guard';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';

const BASE = 'recesso/solicitar';
const MIGALHAS_BASE = [
  { label: 'Recesso', url: '/recesso' },
  { label: 'Solicitar Recesso', url: `/${BASE}` },
];

const carregarCadastro = () =>
  import('./cadastro/cadastro-recesso.component').then((m) => m.CadastroRecessoComponent);

export const solicitarRecessoRoutes: Routes = [
  {
    path: 'recesso/solicitar',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./meus-recessos/meus-recessos.component').then((m) => m.MeusRecessosComponent),
        data: {
          title: 'Solicitar Recesso',
          roles: [Role.RECESSO_CONSULTAR],
          breadcrumb: [
            { label: 'Recesso', url: '/recesso' },
            { label: 'Solicitar Recesso', url: '/recesso/solicitar' },
          ],
        },
      },
      {
        path: 'novo',
        loadComponent: carregarCadastro,
        canDeactivate: [alteracoesNaoSalvasGuard],
        data: {
          title: 'Solicitar Recesso',
          modo: 'cadastrar',
          roles: [Role.RECESSO_CADASTRAR_EDITAR],
          breadcrumb: [...MIGALHAS_BASE, { label: 'Solicitar Recesso', url: `/${BASE}/novo` }],
        },
      },
      {
        path: ':id/editar',
        loadComponent: carregarCadastro,
        canDeactivate: [alteracoesNaoSalvasGuard],
        data: {
          title: 'Editar Recesso',
          modo: 'editar',
          roles: [Role.RECESSO_CADASTRAR_EDITAR],
          breadcrumb: [...MIGALHAS_BASE, { label: 'Editar Recesso', url: `/${BASE}` }],
        },
      },
    ],
  },
];
